import './ApiShipOption.html';
import './CheckoutPointOption.html';
import './DpdOption.html';
// import './EdostPickPointOption.html';
import './EdostSelectOption.html';
import './LPostPointOption.html';
import './MeasoftOption.html';
import './PecOption.html';
import './PointDeliveryMapOption.html';
import './PointDeliverySelectOption.html';
import './RangePriceAndDistanceOption.html';
import './RangeWeightAndDistanceOption.html';
import './SdekOption.html';
import './SdekWidjetOption.html';
import './YandexDeliveryOption.html';
import './YandexDeliveryWidgetOption.html';
import './DeliveryByZonesOption.html';
import './FivePostPointOption.html';
import './FivePostWidgetOption.html';
